"use strict";

var _classCallCheck = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CacheService = exports.DEFAULT_OPTIONS = void 0;
/** The default cache service options. */

exports.DEFAULT_OPTIONS = {};
/**
 * Manages short-term, or ephemeral data points.
 * @remarks
 * This service is meant to speed up your application, and should only be used when performance
 * can benefit from caching data. Generally, the usage of a cache service adds an unnecessary
 * layer of complexity, so avoid using it unless the application's performance demands it.
 */

var CacheService = function CacheService(options) {
  _classCallCheck(this, CacheService);

  this.options = Object.assign(Object.assign({}, exports.DEFAULT_OPTIONS), options);
};

exports.CacheService = CacheService;